function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useTheme } from "../../styles";
import { Text } from "../Text";
import { TextInput } from "../TextInput";
import { View } from "../View";
/**
 * This component renders an editable form for "lessons learned" entries,
 * allowing users to modify existing lessons.
 *
 * Props:
 *
 * - `data`: An array of LessonLearned objects containing the current lessons.
 * - `onEdit`: A callback function to handle updates to the lessons.
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̆̀̀̃̆̀̀̂̎̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̃̆̀̀̂̌̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̀̀̀̃̂̀̀̃̉̀̀̃̈̀̀̃̆̀̀̃̈̀̀̃̈̀̀̃̇̀̀̂̍̀̀̃́̀̀̆̅̀̀̃̄̀̀̆̄̀̀̂̍̀̀̃̄̀̀̆̅̀̀̃̈̀̀̆̆̀̀̂̍̀̀̃̉̀̀̃̀̀̀̃̀̀̀̃̅̀̀̂̍̀̀̃̄̀̀̃̂̀̀̃̆̀̀̃̆̀̀̆̆̀̀̃̃̀̀̃̀̀̀̆̂̀̀̃̅̀̀̃̆̀̀̆̆̀̀̆̄̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̈̀̀̃́̀̀̃̉̀̀̂̍̀̀̃́̀̀̃̇̀̀̃̄̀̀̃̉̀̀̃̄̀̀̃̃̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̆̀̀̃̆̀̀̃̂̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃̆̀̀̃̃̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-10}
 */ export var EditLessonsLearnedForm = function(param) {
    var data = param.data, onEdit = param.onEdit;
    var theme = useTheme().theme;
    var updateLessonsLearned = useCallback(function(index, lesson) {
        var newData = data.map(function(item, i) {
            return i === index ? _object_spread_props(_object_spread({}, item), {
                text: lesson
            }) : item;
        });
        onEdit(newData);
    }, [
        data,
        onEdit
    ]);
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            gap: 15
        },
        children: [
            /*#__PURE__*/ _jsx(Text, {
                text: "Lesson from each session",
                weight: "semibold",
                color: theme.color.gray300,
                size: 15
            }),
            /*#__PURE__*/ _jsx(View, {
                children: (data === null || data === void 0 ? void 0 : data.length) ? data.map(function(lesson, index) {
                    return /*#__PURE__*/ _jsxs(View, {
                        row: true,
                        style: {
                            marginBottom: 10,
                            alignItems: 'flex-start'
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                style: {
                                    marginTop: 12,
                                    width: 35
                                },
                                text: index + 1,
                                color: theme.color.gray300
                            }),
                            /*#__PURE__*/ _jsx(TextInput, {
                                testID: "lesson-".concat(index),
                                style: {
                                    flexGrow: 1
                                },
                                value: lesson.text,
                                onChangeValue: function(newValue) {
                                    updateLessonsLearned(index, newValue);
                                },
                                multiline: true
                            })
                        ]
                    }, index);
                }) : null
            })
        ]
    });
};
